export default __webpack_public_path__ + "static/natalie-bench-83fcaca167e53cb74219061f0bb5b2f4.png";